<template>
  <div>
    <v-card outlined class="rounded-card">
      <div class="grey lighten-2">
        <px-aprovacao-solicitacao-item-header @update="emitUpdate"
                                              :aprovacao="aprovacao"/>
      </div>
      <div>
        <px-aprovacao-solicitacao-item-content @update="emitUpdate"
                                               :aprovacao="aprovacao"/>
      </div>
    </v-card>
  </div>
</template>

<script>
import AprovacaoSolicitacaoItemContent
  from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoItemContent.vue';
import AprovacaoSolicitacaoItemHeader
  from '@/modules/aprovacao-solicitacao/AprovacaoSolicitacaoItemHeader.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoSolicitacaoItemContent: AprovacaoSolicitacaoItemContent,
    pxAprovacaoSolicitacaoItemHeader: AprovacaoSolicitacaoItemHeader,
  },
};
</script>
